
import { HashRouter, Route, Routes, Navigate } from "react-router"
import NotFound from "./pages/NotFound"
import Home from "./pages/Home"




export const RoutePages = () => {
  return <HashRouter>
    <Routes>
          <Route path="/" element={<Navigate to="articles/README" />} >
          </Route>
            <Route index path="articles/:name" Component={Home} />
          <Route path="*" Component={NotFound}/>
    </Routes>
  </HashRouter>
}